/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CapTableModel = {
  id?: number;
  slug?: string;
  created_at?: string;
  updated_at?: string;
  sheet_attribute_mapping?: Record<string, string | null> | null;
  cell_annotations?: Record<string, Record<string, {
    row_mode?: 'single_cell' | 'single_row' | 'multi_row';
    columns_config?: Array<any>;
    rows?: Array<{
      position?: number;
      value?: string | null;
      metadata?: any;
    }>;
  }>>;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  shares_outstanding?: string | null;
  shares_diluted?: string | null;
  current_own_percent?: string | null;
  diluted_own_percent?: string | null;
  initial_liquidation_preference?: string | null;
  is_primary?: boolean;
  waterfall_breakpoints?: any;
  incremental_distribution?: any;
  distribution_percent?: any;
  use_custom_breakpoints?: boolean;
  custom_breakpoints?: any;
  has_liquidation_preference_ledger?: boolean;
  has_dividend_rate_ledger?: boolean;
  is_waterfall_visible?: boolean;
  access_level?: CapTableModel.access_level;
  created_by?: number | null;
  company_measurement_date?: number | null;
};
export namespace CapTableModel {
  export enum access_level {
    COLLABORATIVE = 'collaborative',
    RESTRICTED = 'restricted',
    PRIVATE = 'private',
  }
}

